import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Reports.css";

function ReportsPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">Reports Page</h1>
                <p className="main-description">Welcome to the Reports page!</p>
            </main>
        </div>
    );
}

export default ReportsPage;